import React, { useEffect, useState } from "react";
import { auth, db } from "../../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Grid,
  Avatar,
  Typography,
  CircularProgress
} from "@mui/material";

import { toast } from "react-toastify";

function Schooldetails() {

  const [schoolId, setSchoolId] = useState(null);
  const [loading, setLoading] = useState(true);

  const [school, setSchool] = useState({
    schoolName: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    email: "",
    mobile: "",
    renewalAmount: "",
    renewalDate: "",
    status: "",
    logo: ""
  });

  // Fetch schoolId from users collection
  const fetchSchoolId = async () => {
    try {

      const user = auth.currentUser;

      if (!user) {
        toast.error("User not logged in");
        return;
      }

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {

        const data = userSnap.data();
        const sid = data.schoolId;

        setSchoolId(sid);

        fetchSchool(sid);

      } else {
        toast.error("User document not found");
      }

    } catch (error) {
      console.error(error);
      toast.error("Error fetching user");
    }
  };

  // Fetch school details
  const fetchSchool = async (sid) => {
    try {

      const schoolRef = doc(db, "schools", sid);
      const schoolSnap = await getDoc(schoolRef);

      if (schoolSnap.exists()) {

        setSchool(schoolSnap.data());

      } else {
        toast.error("School not found");
      }

      setLoading(false);

    } catch (error) {
      console.error(error);
      toast.error("Error fetching school");
    }
  };

  useEffect(() => {
    fetchSchoolId();
  }, []);

  const handleChange = (e) => {

    const { name, value } = e.target;

    setSchool((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const updateSchool = async () => {
    try {

      if (!schoolId) {
        toast.error("School ID missing");
        return;
      }

      const ref = doc(db, "schools", schoolId);

      await updateDoc(ref, school);

      toast.success("School updated successfully");

    } catch (error) {
      console.error(error);
      toast.error("Update failed");
    }
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1200, margin: "20px auto" }}>

      <Card>

        <CardHeader
          avatar={
            school.logo ? (
              <Avatar src={school.logo} sx={{ width: 60, height: 60 }} />
            ) : null
          }
          title={
            <Typography variant="h5" fontWeight="bold">
              {school.schoolName}
            </Typography>
          }
          subheader={`Status: ${school.status}`}
        />

        <CardContent>

          <Grid className="row" >

            <Grid className="col-sm-3 mb-3" item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="School Name"
                name="schoolName"
                value={school.schoolName}
                onChange={handleChange}
              />
            </Grid>

            <Grid className="col-sm-3 mb-3" item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Address"
                name="address"
                value={school.address}
                onChange={handleChange}
              />
            </Grid>

            <Grid className="col-sm-3 mb-3" item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="City"
                name="city"
                value={school.city}
                onChange={handleChange}
              />
            </Grid>

            <Grid className="col-sm-3 mb-3" item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="State"
                name="state"
                value={school.state}
                onChange={handleChange}
              />
            </Grid>

            <Grid className="col-sm-3 mb-3" item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Pincode"
                name="pincode"
                value={school.pincode}
                onChange={handleChange}
              />
            </Grid>

            <Grid className="col-sm-3 mb-3" item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Mobile"
                name="mobile"
                value={school.mobile}
                onChange={handleChange}
              />
            </Grid>

            <Grid className="col-sm-3 mb-3" item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Email"
                name="email"
                value={school.email}
                onChange={handleChange}
              />
            </Grid>

            <Grid className="col-sm-3 mb-3" item xs={12} md={3} sx={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="contained"
                fullWidth
                onClick={updateSchool}
              >
                Update School
              </Button>
            </Grid>

          </Grid>

        </CardContent>

      </Card>

    </Box>
  );
}

export default Schooldetails;